const Buffer = require('buffer').Buffer;

const BLE = require('../../io/ble');
const VirtualMachine = require('../../virtual-machine');

/**
 * Manage communication with a common peripheral over a Scratch Link client socket.
 */
class SensorPeripheral{

    /**
     * Construct a common communication object.
     * @param {Runtime} runtime - the Scratch runtime
     * @param {string} deviceId - the id of the peripheral
     * @param {string} originalDeviceId - the original id of the peripheral, like xxx_arduinoUno
     * @param {object} bleConfig - the ble config of the peripheral
     * @param {object} diveceOpt - the device optione of the peripheral
     */
    constructor (runtime, deviceId, originalDeviceId, bleConfig, diveceOpt) {
        /**
         * The Scratch runtime used to trigger the green flag button.
         * @type {Runtime}
         * @private
         */
        this._runtime = runtime;

        this.bleConfig = bleConfig;
        this.diveceOpt = diveceOpt;

        /**
         * The ble connection socket for reading/writing peripheral data.
         * @type {BLE}
         * @private
         */
        this._runtime.registerPeripheralExtension(deviceId, this);

        /**
         * The id of the peripheral this peripheral belongs to.
         */
        this._deviceId = deviceId;

        this._originalDeviceId = originalDeviceId;

        /**
        * Pending data list. If busy is set when send, the data will push into this array to
        * waitting to be sended.
        */
        this._pendingData = [];

        this.reset = this.reset.bind(this);
        this._onConnect = this._onConnect.bind(this);
        this._onMessage = this._onMessage.bind(this);
    }

    /**
     * Called by the runtime when user wants to upload code to a peripheral.
     * @param {string} code - the code want to upload.
     */
    upload (code) {

    }

    /**
     * Called by the runtime when user wants to upload realtime firmware to a peripheral.
     */
    uploadFirmware () {

    }


    /**
     * Called by the runtime when user wants to abort the uploading process.
     */
    abortUpload () {
    }

    /**
     * Called by the runtime when user wants to scan for a peripheral.
     * @param {Array.<string>} pnpidList - the array of pnp id list
     * @param {bool} listAll - wether list all connectable device
     */
    scan (pnpidList, listAll) {
        
    }

    /**
     * Called by the runtime when user wants to connect to a certain peripheral.
     * @param {string} deviceName - the id of the peripheral to connect to.
     */
    connect (deviceName) {
        
    }

    /**
     * Disconnect from the peripheral.
     */
    disconnect () {
        
    }

    /**
     * Reset all the state and timeout/interval ids.
     */
    reset () {
    }

    /**
     * Return true if connected to the peripheral.
     * @return {boolean} - whether the peripheral is connected.
     */
    isConnected () {
        
    }

    /**
     * Write data to the peripheral serialport.
     * @param {string} data - the data to write.
     */
    write (data) {
        
    }

    /**
     * Send a message to the peripheral Serialport socket.
     * @param {Uint8Array} message - the message to write
     */
    send (message) {
        
    }

    /**
     * Starts reading data from peripheral after serialport has connected to it.
     * @private
     */
    _onConnect () {
    }

    /**
     * Process the sensor data from the incoming serialport characteristic.
     * @param {object} base64 - the incoming serialport data.
     * @private
     */
    _onMessage (base64) {
        const consoleData = Buffer.from(base64, 'base64');
        this._runtime.emit(this._runtime.constructor.PERIPHERAL_RECIVE_DATA, consoleData);
    }
}

module.exports = SensorPeripheral;
